<template>
    <div class="socket-reconnect-modal">
        <div class="modal-content relative">
            <div class="modal-header flex justify-center">
                <h3 class="font-size-18 shadow-text-none p-0 m-0">{{ title }}</h3>
            </div>

            <div class="modal-body">
                <div class="block">
                    <p class="text-center mb-3">
                        <i :class="[icon, 'font-size-40 text-grey']"></i>
                    </p>
                    <div class="shadow-text-none font-size-14 text-center mt-3 md:mt-0">
                        {{ message }}
                        <div class="shadow-text-none" v-if="showRetryMessage" style="color: red;">{{ retryFailMessage }}</div>
                    </div>
                </div>
            </div>

            <div v-if="showFooter" class="modal-footer flex flex-wrap">
                <div class="w-1/2 text-right">
                    <button @click="retry" :disabled="disabled" class="btn btn-reject font-opensans mr-2">
                        {{ $t('socket_retry') }} <template v-if="this.countdownCounter > 0">({{ this.countdownCounter }})</template>
                    </button>
                </div>

                <div class="w-1/2">
                    <button @click="onClickOk" :disabled="disabled" class="btn font-opensans">{{ okButton }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const retrySec = 5

export default {
    name: 'SocketReconnectModal',

    props: {

        icon: {
            type: String,
            default: 'fas fa-cloud-moon-rain'
        },

        title: {
            type: String,
            default () {
                return this.$t('socket_reconnect_title')
            }
        },

        message: {
            type: String,
            default () {
                return this.$t('socket_reconnect_message')
            }
        },

        showFooter: {
            type: Boolean,
            default: false
        },

        okButton: {
            type: String,
            default () {
                return this.$t('socket_close_btn')
            }
        },

        retryFailMessage: {
            type: String,
            default () {
                return this.$t('socket_retry_connect_fail')
            }
        }
    },

    data () {
        return {
            disabled: false,
            countdownCounter: retrySec,
            retryTimer: null,
            showRetryMessage: false
        }
    },

    mounted () {
        if (this.showFooter) {
            this.countDownRetry()
        }
    },

    methods: {

        retry () {
            this.countdownCounter = retrySec
            this.disabled = true
            this.showRetryMessage = false
            this.countDownRetry()
        },

        countDownRetry () {
            this.disabled = true
            this.retryTimer = setInterval(() => {

                if (this.countdownCounter === 0) {
                    this.disabled = false
                    this.showRetryMessage = true
                    return clearInterval(this.retryTimer)
                }

                this.countdownCounter--
            }, 1000)
        },

        clearRetryTimer () {
            clearInterval(this.retryTimer)
        },

        onClickOk () {
            this.$emit('ok', {
                title: this.title,
                message: this.message,
                okButton: this.okButton
            })
        }
    },

    destroyed () {
        this.clearRetryTimer()
    }
}
</script>

<style lang="scss" scoped>

@import '@/scss/variable.scss';
@import '@/scss/mixin.scss';

.btn {
    padding-left: 1rem;
    padding-right: 1rem;
}

.socket-reconnect-modal {
    font-family: 'Open Sans', sans-serif !important;
    background-color: rgba(0, 0, 0, .2);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: start;
    font-size: 1.2em;
    z-index: 9999;

    .modal-content {
        background-color: #fff;
        margin-top: 4rem;
        padding: 1rem 1.5rem;
        width: 500px !important;
        overflow: hidden;
        border-radius: 3px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, .6);

        @include screen-max-md {
            width: 90% !important;
            margin: 1rem .5rem;
        }

        .modal-body {
            margin: 0.5rem 0 1rem 0;
        }
    }
}

</style>
